import { render, staticRenderFns } from "./DynamicTag.vue?vue&type=template&id=52a30cbc"
import script from "./DynamicTag.vue?vue&type=script&lang=js"
export * from "./DynamicTag.vue?vue&type=script&lang=js"
import style0 from "./DynamicTag.vue?vue&type=style&index=0&id=52a30cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports